import{LitElement as t,html as s,css as e}from"lit";import{property as o,state as i,customElement as l}from"lit/decorators.js";import{modalDialogStyles as n,modalDialogBodyStyles as c,modalHelpSection as a,backdropStyles as r,modalAnimations as d,modalWalletsSection as p}from"./styles.js";var h=Object.defineProperty,g=Object.getOwnPropertyDescriptor,m=(t,s,e,o)=>{for(var i,l=o>1?void 0:o?g(s,e):s,n=t.length-1;n>=0;n--)(i=t[n])&&(l=(o?i(s,e,l):i(l))||l);return o&&l&&h(s,e,l),l};let u=class extends t{constructor(){super(...arguments),this.showModal=!1,this.loadingAccounts=!1,this.closingModal=!1,this.modalTitle="Pick your account",this.accounts=[]}connectedCallback(){super.connectedCallback()}async pickAccount(t){this.closingModal=!0,await new Promise((t=>setTimeout(t,280))),this.dispatchEvent(new CustomEvent("account-selected",{detail:t,bubbles:!0,composed:!0})),this.closingModal=!1}async closeModal(){this.closingModal=!0,await new Promise((t=>setTimeout(t,280))),this.showModal=!1,this.dispatchEvent(new CustomEvent("account-selector-closed",{detail:new Error("Account selector closed"),bubbles:!0,composed:!0})),this.closingModal=!1}render(){const t=s`
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <style>
          .spinner_qM83 {
            animation: spinner_8HQG 1.05s infinite;
            fill: white;
          }
          .spinner_oXPr {
            animation-delay: 0.1s;
          }
          .spinner_ZTLf {
            animation-delay: 0.2s;
          }
          @keyframes spinner_8HQG {
            0%,
            57.14% {
              animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);
              transform: translate(0);
            }
            28.57% {
              animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);
              transform: translateY(-6px);
            }
            100% {
              transform: translate(0);
            }
          }
        </style>
        <circle class="spinner_qM83" cx="4" cy="12" r="3" />
        <circle class="spinner_qM83 spinner_oXPr" cx="12" cy="12" r="3" />
        <circle class="spinner_qM83 spinner_ZTLf" cx="20" cy="12" r="3" />
      </svg>
    `,e=s`
      <ul class="wallets-body">
        ${this.accounts.map((({publicKey:t,index:e})=>s`
            <li @click="${()=>this.pickAccount({publicKey:t,index:e})}" class="wallets-body__item">
              <span style="margin-right: 1rem;" class="dialog-text-solid">
                ${t.slice(0,4)}....${t.slice(-6)}
              </span>
              <span class="dialog-text">(44'/148'/${e}')</span>
            </li>
          `))}
      </ul>
    `;return s`
      <dialog style="" class="dialog-modal ${this.closingModal?"closing":""}" .open=${this.showModal}>
        <section class="dialog-modal-body">
          <div class="dialog-modal-body__wallets">
            <section class="wallets-container">
              <header class="wallets-header">
                <h2 class="wallets-header__modal-title dialog-text-solid">${this.modalTitle}</h2>

                <button @click=${()=>this.closeModal()} class="wallets-header__button">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#000000"
                    height="20px"
                    width="20px"
                    viewBox="0 0 490 490">
                    <polygon
                      points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490   489.292,457.678 277.331,245.004 489.292,32.337 " />
                  </svg>
                </button>
              </header>

              ${this.loadingAccounts?t:e}
            </section>
          </div>
        </section>
      </dialog>

      <div
        style="position: fixed; z-index: 950"
        class="backdrop ${this.closingModal?"closing":""}"
        @click=${()=>this.closeModal()}></div>
    `}};u.styles=[e`
      :host * {
        box-sizing: border-box;
      }

      .mb-0 {
        margin-bottom: 0 !important;
      }
    `,n,c,a,r,d,p],m([o({type:Boolean,reflect:!0})],u.prototype,"showModal",2),m([o({type:Boolean,reflect:!0})],u.prototype,"loadingAccounts",2),m([i()],u.prototype,"closingModal",2),m([o({type:String,reflect:!0})],u.prototype,"modalTitle",2),m([o({type:String,reflect:!0,converter:t=>t?JSON.parse(t):[]})],u.prototype,"accounts",2),u=m([l("stellar-accounts-selector")],u);export{u as StellarSelectorModal};
//# sourceMappingURL=stellar-selector-modal.js.map
